// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"791e3fd7","232":"e149d34e","237":"3c1ba5ee","526":"96260007","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};